import React from 'react';
import { Button, Skeleton } from '@/ui';

// Loading + error states for InspectionView. Lifted out during the
// 2026-05-01 split.

export const LoadingState: React.FC = () => (
  <div className="max-w-2xl mx-auto px-4 py-6 space-y-4">
    <Skeleton className="h-8 w-2/3" />
    <Skeleton className="h-4 w-1/3" />
    <Skeleton className="h-10 w-full" />
    <Skeleton className="h-40 w-full" />
  </div>
);

export const ErrorState: React.FC<{
  message: string | null;
  onBack: () => void;
}> = ({ message, onBack }) => (
  <div className="max-w-2xl mx-auto text-center py-16 px-4">
    <p className="text-ink-muted text-body-md">{message ?? 'Inspection not found.'}</p>
    <Button
      variant="ghost"
      size="sm"
      className="mt-4"
      onClick={onBack}
    >
      Back to inspections
    </Button>
  </div>
);
